import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import aiService from "services/aiService";

export const getIssueRemedy = createAsyncThunk(
    "ai/getIssueRemedy",
    async (data, { rejectWithValue }) => {
        try {
            return await aiService.getIssueRemedy(data?.params);
        } catch (error) {
            return rejectWithValue();
        }
    }
);

export const approveRemediationStep = createAsyncThunk(
    "ai/approveRemediationStep",
    async ({ stepId, approved }, { rejectWithValue }) => {
        try {
            await aiService.approveRemediationStep({ stepId, approved });
            return { stepId, approved };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    issueRemedy: null,
    issueRemedyLoading: false,
};

export const aiSlice = createSlice({
    name: "aiSlice",
    initialState,
    reducers: {
        resetIssueRemedy: (state) => {
            state.issueRemedy = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getIssueRemedy.pending, (state) => {
            state.issueRemedy = null;
            state.issueRemedyLoading = true;
        });
        builder.addCase(getIssueRemedy.fulfilled, (state, action) => {
            state.issueRemedy = action.payload.data;
            state.issueRemedyLoading = false;
        });
        builder.addCase(getIssueRemedy.rejected, (state) => {
            state.issueRemedyLoading = false;
        });

        builder.addCase(approveRemediationStep.fulfilled, (state, action) => {
            const { stepId, approved } = action.payload;
            if (state.issueRemedy?.steps) {
                state.issueRemedy.steps = state.issueRemedy.steps.map((step) =>
                    step.stepId === stepId
                        ? { ...step, userApproval: approved }
                        : step
                );
            }
        });
    },
});

export const { resetIssueRemedy } = aiSlice.actions;

export default aiSlice.reducer;